<template>
  <span class="login100-form-title p-b-41">
    Iniciar sesion
  </span>

  <form class="login100-form validate-form p-b-33 p-t-5" @submit.prevent="onSubmit">
    <div class="wrap-input100 validate-input" data-validate="Ingrese correo">
      <input
        v-model="usuario.email"
        class="input100"
        type="email"
        placeholder="Correo"
        autocomplete="off"
        required
      >
      <span class="focus-input100" data-placeholder="&#xe82a;"></span>
    </div>

    <div class="wrap-input100 validate-input" data-validate="Ingrese contrasena">
      <input
        v-model="usuario.password"
        class="input100"
        type="password"
        placeholder="Contrasena"
        autocomplete="off"
        required
      >
      <span class="focus-input100" data-placeholder="&#xe80f;"></span>
    </div>

    <div class="container-login100-form-btn m-t-32">
      <button class="login100-form-btn">
        Login
      </button>
    </div>
  </form>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import useAuth from '../composables/useAuth'
import Swal from 'sweetalert2'

export default {
  setup() {
    const router = useRouter()
    const { loginUser } = useAuth()

    const usuario = ref({
      email: '',
      password: ''
    })

    return {
      usuario,
      onSubmit: async () => {
        const { ok, message } = await loginUser(usuario.value)

        if (!ok) {
          Swal.fire('Error', message, 'error')
          return
        }

        router.push({ name: 'list' })
      }
    }
  }
}
</script>
